import React from "react";

import "../../../../styles/css/App.css";

import { Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import * as Constants from "../../../../consts/Constants.js";
import BlueMarker from "../../../../assets/images/markers/blueMarker.png";

import LiveTable from "./live-table"

import alerter from "../../../alerts/alerter"
import service from '../../../../plas/eboards/vehicles/service';

function LiveMap({ history }) {

  const [vehicles, setVehicles] = React.useState([]);

  let timer = React.useRef(null);

  React.useEffect(() => {
    loadVehicles();
    timer.current = setInterval(() => loadVehicles(), 10000);
  }, []);

  React.useEffect( () => () => {
    clearInterval(timer.current);
    timer.current = null;
  }, [] );


  const loadVehicles = () => {
    service.api.status.get((response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setVehicles(response.result);
      }
    });
  }

  const markerIcon = new L.Icon({
      iconUrl: BlueMarker,
      popupAnchor: [0, -30],
      iconSize: new L.Point(26, 39),
      iconAnchor: [13, 39]
  });

  const ColoredLine = ({ color, marginTop, marginBottom }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          marginTop: marginTop !== undefined ? marginTop : 6,
          marginBottom: marginBottom !== undefined ? marginBottom : 16,
          height: 2
        }}
      />
  );

  return (
    <div>
      <Grid container>
        <Grid item xs={false} lg={1} />
        <Grid item xs={12} lg={10}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={true}>
                  <p style={{ fontSize: '28px', textAlign: 'left'}}>
                    Mapa en vivo
                  </p>
                </Grid>
              </Grid>
              <ColoredLine color="gray"/>
            </Grid>
            <Grid item xs={12} md={true}>
              <LiveTable title={"Vehículos"} vehicles={vehicles}/>
            </Grid>
            <Grid item xs={12} md={"auto"}>
              <MapContainer 
                style={{
                  height: "100%",
                  minHeight: "300px",
                  width: "100%",
                  minWidth: "300px",
                  overflow: "hidden",
                  zIndex: '399'
                }}
                center={{lat: Constants.LATITUD_AYACUCHO, lng: Constants.LONGITUD_AYACUCHO}}
                zoom={14}
                scrollWheelZoom={true}>
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                { vehicles.map((vehicle) => (vehicle.lastFixGnssStatus) ? (
                  <Marker
                    key={vehicle.eboardId}
                    icon={markerIcon}
                    position={{lat: vehicle.lastFixGnssStatus.fix.latitude, lng: vehicle.lastFixGnssStatus.fix.longitude}}>
                  </Marker>
                  ) : (null)
                )}
              </MapContainer>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={false} lg={1} />
      </Grid>
    </div>
  );

}

export default withRouter(LiveMap);
